import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import ReactSVG from "react-svg";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { Text, Button } from "~/components/elements";
import { useDispatch, useSelector } from "react-redux";
import { Creators as AccountActions } from "~/store/modules/account/actions";

import LogoPromo from "~/assets/img/icon/logo-brand.svg";
import MenuClosed from "~/assets/img/icon/menu-closed.svg";
import MenuOpened from "~/assets/img/icon/menu-opened.svg";
import Login from "~/assets/img/icon/login.svg";
import promoIsActive from "~/utils/promoIsActive";

import * as S from "./styles";

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch()
  useEffect(() => {
    document.body.classList.toggle("menu-open", showMenu);
  }, [showMenu]);

  const personalDataName = useSelector(
    (state) => state.authentication.auth.user.nome
  );

  const personalData = useSelector(
    (state) => state.account.details.dadosPessoais
  );

  const isPromoActive = promoIsActive();

  useEffect(() => {
    if(personalDataName){
      dispatch(AccountActions.getUserDetails());
    }
  }, [dispatch]);

  return (
    <S.HeaderContainer>
      <S.HeaderBg>
        <Grid container justifyContent="space-between" alignItems="center">
          <S.ContentHolder>
            <S.LogoHolder>
              <Link to={`/${location.search}`}>
                <ReactSVG src={LogoPromo} />
              </Link>
            </S.LogoHolder>
            <S.MenuIconHolder>
              <ReactSVG
                onClick={() => setShowMenu(!showMenu)}
                src={showMenu ? MenuOpened : MenuClosed}
              />
            </S.MenuIconHolder>
          </S.ContentHolder>

          <div style={{ display: "flex", alignItems: "center", gap: "24px"}}>
            <S.GridLinks>
              <S.HashLinkStyle smooth to={`/${location.search}#como-participar`}>
              <Text as="span" level="4">
                COMO PARTICIPAR
              </Text>
              </S.HashLinkStyle>

              <S.HashLinkStyle smooth to={`/faq#conteudo`}>
                <Text as="span" level="4">
                  DÚVIDAS FREQUENTES
                </Text>
              </S.HashLinkStyle>
              <S.HashLinkStyle smooth to={`/regulamento${location.search}#conteudo`}>
                <Text as="span" level="4">
                  REGULAMENTO
                </Text>
              </S.HashLinkStyle>
            </S.GridLinks>

            <S.ActionsMenuDesk>
              <Link to={`/minha-conta${location.search}`}>
                <S.BtnLogin variant="outlined">
                  <ReactSVG wrapper="span" src={Login} />
                  <Text as="span" level="2" id="btnAcesseSuaConta">
                    {personalDataName ? personalDataName : "ENTRE NA CONTA"}
                  </Text>
                </S.BtnLogin>
              </Link>
              {isPromoActive && (
                  <>
                    {personalData?.cupons?.length === 1 ? (
                      <S.BtnParticipe color="disabled" disabled={true}>
                        {personalDataName ? "CADASTRAR PRODUTO" : "PARTICIPE AGORA!"}
                      </S.BtnParticipe>
                    ) :  personalData?.cupons?.length < 20 ||  !personalData?.cupons ? (
                      <Link
                        to={
                          personalDataName
                            ? `/cadastro-promo${location.search}`
                            : `/cadastre-se${location.search}`
                        }
                      >
                        <S.BtnParticipe
                          color={personalData?.cupons?.length === 1 ? "disabled" : "secondary"}
                          disabled={personalData?.cupons?.length === 1}
                        >
                          {personalDataName ? "CADASTRAR PRODUTO" : "PARTICIPE AGORA!"}
                        </S.BtnParticipe>
                      </Link>
                    ) : null}
                  </>
                )}
            </S.ActionsMenuDesk>
          </div>

          {showMenu ? (
            <S.Menu>
              <S.MenuMobileHolder>
                <HashLink
                    smooth
                    to={`/${location.search}#`}
                    onClick={() => setShowMenu(!showMenu)}
                  >
                  <Text as="anchor" level="2" className={"blueSpan"}>
                    INÍCIO
                  </Text>
                </HashLink>
                <HashLink
                  smooth
                  to={`/${location.search}#como-participar`}
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <Text as="anchor" level="2" className={"blueSpan"}>
                    COMO PARTICIPAR
                  </Text>
                </HashLink>
                <HashLink to={`/faq${location.search}#conteudo`}>
                  <Text as="anchor" level="2" className={"blueSpan"}>
                    DÚVIDAS FREQUENTES
                  </Text>
                </HashLink>
                <HashLink to={`/regulamento${location.search}#conteudo`}>
                  <Text as="anchor" level="2" className={"blueSpan"}>
                    REGULAMENTO
                  </Text>
                </HashLink>
              </S.MenuMobileHolder>

              <S.ActionsMenuMobile>
                <Link
                  to={`/minha-conta${location.search}`}
                  onClick={() => setShowMenu(!showMenu)}
                >
                  <S.BtnLogin>
                    <ReactSVG wrapper="span" src={Login} />
                    <Text as="span" color="primary" level="2" id="btnAcesseSuaConta" className={"text-blue userButton"}>
                      {personalDataName ? personalDataName : "ENTRE NA CONTA"}
                    </Text>
                  </S.BtnLogin>
                </Link>
                {isPromoActive && (
                  <>
                    {personalData?.cupons?.length === 1 ? (
                      <Button color="disabled" disabled>
                        {personalDataName
                          ? "CADASTRAR PRODUTO"
                          : "PARTICIPE AGORA!"}
                      </Button>
                    ) : personalData?.cupons?.length < 20 || !personalData?.cupons  ? (
                      <Link
                        to={personalDataName ? "/cadastro-promo" : "/cadastre-se"}
                        onClick={() => setShowMenu(!showMenu)}
                      >
                        <Button color="terciary">
                          {personalDataName
                            ? "CADASTRAR PRODUTO"
                            : "PARTICIPE AGORA!"}
                        </Button>
                      </Link>
                    ) : null}
                  </>
                )}
              </S.ActionsMenuMobile>
            </S.Menu>
          ) : null}
        </Grid>
      </S.HeaderBg>
      {/* <S.MessageEnd>
        <p>Período de cadastro na promoção encerrado.</p>
      </S.MessageEnd> */}
    </S.HeaderContainer>
  );
}
